<section id="daily-quote">
    <div [ngStyle]="{'background': '#464646 url(' + quotesObj.background + ')'}" class="hero hero-daily-quote"></div>
    <div class="container">
      <div class="row">
        <div class="col-md-7 col-md-offset-1">
          <h2 class="heading-lg">Daily quote</h2>
          <p class="text text-lg">{{quotesObj.quote}}</p>
        </div>
      </div>
    </div>
  </section>


// WEBPACK FOOTER //
// /Volumes/Projects/WellBrain_Azure_Web/src/app/components/dailyquotes/dailyquotes.component.html